import React from "react";
import { Helmet } from "react-helmet";
import AboutMe from "./components/aboutme";
import Banner from "./components/banner";
import Experience from "./components/experience";
import MyServices from "./components/myServices";
import Projects from "./components/projects";
import SayHello from "./components/sayHello";
import Skills from "./components/skills";

const Prime = ({ theme }) => {
  return (
    <div
      className={`${
        theme === "dark" ? "  dark:bg-darkBgColor" : "bg-lightBgColor"
      } w-full h-auto`}
    >
      <Helmet>
        <title>Noor Mohammad | Mern Stack Develoer</title>
      </Helmet>
      <div className="max-w-6xl px-10 xl:px-0 mx-auto font-bodyFont">
        <Banner theme={theme} />
        <AboutMe theme={theme} />
        <MyServices theme={theme} />
        <Experience theme={theme} />
        <Skills theme={theme} />
        <Projects theme={theme} />
        <SayHello theme={theme} />
      </div>
    </div>
  );
};

export default Prime;
